
    import { defineComponent, PropType, reactive, ref } from 'vue'
    import BaseInputOutlined from '@root/src/components/inputs/BaseInputOutlined.vue'
    import api from '@api/api'
    export default defineComponent({
        name: 'InvoiceForm',
        emits: ['back', 'cancel', 'submit-invoice'],
        components: {BaseInputOutlined},
        props: {
            price: { type: String, required: true },
            periodStart: { type: String, required: true },
            projectId: { type: String, required: true },
            period: { type: String, required: true },
            selectedContractor: {type: Object, required: false},
            paymentPayloadId: {type: String, required: true},
            tariff: {type: String, required: true},
            projName: {type: String, required: true},
        },
        setup(props, { emit }) {
            const form = reactive({
                inn: props.selectedContractor?.inn,
                kpp: props.selectedContractor?.kpp,
                name: props.selectedContractor?.name,
                addr: props.selectedContractor?.address,
                price: props.price,
                periodStart: props.periodStart,
                period: props.period,
                projectId: props.projectId,
                paymentPayloadId: props.paymentPayloadId,
                contractorExists: props.selectedContractor != undefined,
                tariff: props.tariff,
                projName: props.projName
            });
            const valid = ref(false);

            const selectedOrganization = ref(null);
            const innSuggestions = ref([]);
            const innLoading = ref(false);
            const innSearchQuery = ref('');
            const innSearchTimeout = ref(null);

            const rules = {
                required: (v: string) => !!v,
                inn: (v: string) => /^[0-9]{10,12}$/.test(v),
                tel: (v: string) => /^\+\d{10,15}$/.test(v),
                kpp: (v: string) => !v || /^[0-9]{9}$/.test(v),
                name: (v: string) => !!v,
                addr: (v: string) => !!v,
            };

            const isFieldValid = (fieldName: string) => {
                return rules[fieldName](form[fieldName])
            };

            const invLoading = ref(false)

            const searchOrganizations = async (query: string) => {
                if (!query || query.length < 2) {
                    innSuggestions.value = [];
                    return;
                }
                
                try {
                    innLoading.value = true;
                    const response = await api.marketplace.searchByInn({ name: query });
                    if (response.data) {
                        innSuggestions.value = response.data;
                    }
                } catch (error) {
                    console.error('Ошибка поиска организаций:', error);
                    innSuggestions.value = [];
                } finally {
                    innLoading.value = false;
                }
            };

            const onOrganizationSearch = (query: string) => {
                innSearchQuery.value = query;

                if (innSearchTimeout.value) {
                    clearTimeout(innSearchTimeout.value);
                }

                innSearchTimeout.value = setTimeout(() => {
                    searchOrganizations(query);
                }, 500);
            };

            const onOrganizationSelect = (selectedItem: any) => {
                if (selectedItem && selectedItem.data) {
                    form.inn = selectedItem.data.inn;
                    form.name = selectedItem.value;
                    form.addr = selectedItem.data.address?.value || '';
                    form.kpp = selectedItem.data.kpp || '';

                    selectedOrganization.value = null;
                }
            };

            const submit = async () => {
                if (valid.value) {
                    invLoading.value = true
                    try {
                        const contractorData = {
                            projectId: form.projectId,
                            inn: form.inn,
                            kpp: form.kpp,
                            name: form.name,
                            addr: form.addr
                        }
                        
                        if (form.contractorExists) {
                            await api.marketplace.updateContractor(contractorData)
                            console.log('Контрагент успешно обновлен:', contractorData)
                            emit('back')
                        } else {
                            const result = await api.marketplace.createContractor(contractorData)

                            if (result.data && result.data.success) {
                                console.log('Контрагент успешно создан:', result.data)
                                // Возвращаемся к окну оплаты с данными о созданном контрагенте
                                emit('back', {
                                    type: 'contractor_created',
                                    id: result.data.id,
                                })
                            } else {
                                console.error('Ошибка при создании контрагента:', result.error)
                                throw new Error('Не удалось создать контрагента')
                            }
                        }

                    } catch (error) {
                        console.error('Ошибка при работе с контрагентом:', error)
                    } finally {
                        invLoading.value = false
                    }
                }
            }

            return { 
                form, 
                valid, 
                rules, 
                isFieldValid, 
                submit, 
                invLoading,
                selectedOrganization,
                innSuggestions,
                innLoading,
                innSearchQuery,
                onOrganizationSearch,
                onOrganizationSelect
            };
        },
    });
